// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"9cfeb6a8","769":"612f9393"}[chunkId] + ".chunk.js";
};